export const getSiteCurrency = {
  ZPAR: 'ARS',
  '24MX': 'MXN',
  VAMX: '',
  CAPA: '',
  DVPE: '',
  IWBR: '',
  LLVE: '',
  PLEC: '',
  UBPE: 'PEN',
  WIBR: '',
  CMBR: ''
};

export const getNameColor = {
  SUPERHIGHLIGHTED: 'navent',
  HIGHLIGHTED: 'accessibleGreen',
  SIMPLE: 'primary'
};
